export default __webpack_public_path__ + "static/media/image3.da56084d.jpg";